import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const urinaryTractDisorder: AnswerPathTreeNode = {
  path: 'urinaryTract',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredUrinaryTractDetails }],
};
